import * as React from 'react';
import { connect } from 'react-redux';
import { activeVariantByIdSelector } from './selectors';
import {
  addToFavouriteProducts,
  getLastSeenProducts,
  loadLastSeenProducts,
  loadProductById,
  loadProductUpsell,
  loadRelatedProducts,
  removeFromFavouriteProducts,
  setCurrentProductId,
  setLastSeenProducts,
  setLinkedProducts,
  setRelatedProducts,
  setUpsell,
  updateCurrentProductFavorite,
} from './actions';
import {
  preorderProductTitleTextSelector,
  preorderProductTextSelector,
  preorderProductButtonTextSelector,
} from '../App/selectors';
import { loadPreorderTexts } from '../App/actions';
import {
  CategoriesCol,
  Container,
  MainCol,
  CatalogRow,
} from '../../theme/libraries/grid';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import {
  GalleryCol,
  ProductMetaCol,
  ProductRow,
} from '../../components/Product/ProductStyles';
import {
  ProductAlternatives,
  ProductBody,
  ProductDemandVariantSelect,
  ProductDescription,
  ProductDownloads,
  ProductFavorite,
  ProductForm,
  ProductGallery,
  ProductPrice,
  ProductShortDescription,
  ProductPackagingInfo,
  ProductTitle,
  ProductVariantSelect,
} from '../../components/Product/Product';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import ProductsSlider from '../../components/_helpers/product/ProductsSlider';
import {
  loadFavoriteProductsCount,
  setAddToCartModalProduct,
  setArticleModal,
} from '../App/actions';
import {
  capitalizeFirstLetter,
  getGiftCategoryDesktopBannerFromSettings,
  getGiftWebContentIdFromSettings,
  getPersonalizationColors,
  isCartGiftsValid,
  isCompanyOrSchoolAccount,
  isOutOfStock,
  isPersonalizedProduct,
  isRetail,
  isSsr,
  prop,
  removeHtmlTags,
  scrollToElement,
} from '../../utilities';
import {
  Personalization,
  ProductPersonalizationForm,
  withDefaultPersonalizationColor,
} from '../../components/Product/ProductPersonalization';
import MetaTags from '../../components/MetaTags/MetaTags';
import {
  buildProductJsonLd,
  productMetaHandler,
} from '../../utilities/product';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { rem } from 'polished';
import SideMenu from '../../components/_layout/SideMenu/SideMenu';
import AvailabilityDetail from '../../components/_helpers/product/AvailabilityDetail';
import { Media, MediaContextProvider } from '../../theme/media';
import Tabs, { TabItem } from '../../components/Tabs/Tabs';
import { push } from 'react-router-redux';
import ConfirmModal from '../../components/_helpers/Modal/ConfirmModal';
import ChooseModal from '../../components/_helpers/Modal/ChooseModal';
import { sendViewItemEvent } from '../../utilities/ga4_events';
import {
  ButtonStyledStyles,
  ButtonStyles,
} from '../../components/_helpers/form/Button';
import { ProductUpsell } from './ProductUpsell';
import { ProductManufacturer } from './ProductManufacturer';
import CartShippingRange from '../../components/Cart/CartShippingRange';
import CartGiftSmallWidget from '../../components/Cart/CartGiftSmallWidget';
import IconLazy from '../../components/_helpers/Icon/IconLazy';

const GiftImage = styled.img`
  width: 100%;
  margin-top: ${rem(10)};
  cursor: pointer;
`;

const FlushSideMenu = styled(SideMenu)`
  ${({ theme }) => theme.media('md')} {
    margin-top: -${rem(20)};
  }
`;

const ProductContainer = styled(Container)`
  ${({ theme }) => theme.media('md')} {
    padding-top: ${rem(20)};
  }
`;

const MainColStyled = styled(MainCol)`
  ${({ theme }) => theme.media('md')} {
    margin-bottom: ${rem(16)};
    /* Pull the content (breadcrumb → product) up to match the category page's
       top spacing — the left panel keeps its own -20 flush margin. Without this
       the full 20px ProductContainer top padding shows, a larger gap than other
       pages. */
    && {
      margin-top: -${rem(12)};
    }
  }
`;

const FavoriteMustLoginModal = styled(ChooseModal)``;

const FavoriteAddedModal = styled(ConfirmModal)``;

const FavoriteModalLink = styled.a`
  color: black;
  text-decoration: underline;
`;

const DescriptionButton = styled.a`
  ${ButtonStyles};
  ${ButtonStyledStyles};
  width: fit-content;
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
  flex: 1 0 100%;
  color: ${({ theme }) => theme.color.white};
  background-color: blue; /* For browsers that do not support gradients */
  background-image: linear-gradient(#4f97fe, #2880ff);
  outline: none;
  border: none;

  &:focus {
    border-color: none;
    box-shadow: none;
  }

  &:not(:disabled):hover {
    background: linear-gradient(#4f97fe, #2880ff);
  }
`;

const InfoIcon = styled(IconLazy)`
  /* && (zdvojená trieda) — základný IconWrapper sa načítava lazy cez
     @loadable, jeho fill/size štýly sa injektujú až po týchto a pri rovnakej
     špecificite by vyhrali (ikona by bola čierna). */
  && {
    fill: ${({ theme }) => theme.color.white};
    width: ${rem(20)};
    height: ${rem(20)};
  }
  margin-right: ${rem(5)};
`;

const AlternativesWrapper = styled.div`
  margin-top: ${rem(10)};
`;

const TitleAboveGallery = styled.div`
  max-width: ${rem(530)};
  margin: auto;
`;

const CartShippingRangeStyled = styled(CartShippingRange)`
  margin-top: ${rem(10)};
`;

const AvailabilityDetailStyled = styled(AvailabilityDetail)`
  margin-top: ${rem(15)};
`;

const CartGiftSmallWidgetWrapper = styled.div`
  margin-top: ${rem(10)};
`;

const ProductFavoriteWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const PreorderWrapper = styled.div`
  margin-top: ${rem(10)};
  margin-bottom: ${rem(10)};
`;

const PreorderTitle = styled.div`
  font-weight: bold;
  margin-bottom: ${rem(5)};
`;

const PreorderText = styled.div`
  font-size: ${rem(14)};
  font-weight: bold;
  color: ${({ theme }) => theme.color.primary};
`;

export interface ProductProps {
  product: any;
  connections: any[];
  dispatch: any;
  isCartProcessing: any;
  isError: boolean;
  lang: string;
  user: any;
  defaultTitle: string;
  token: string;
  setActiveVariant: any;
  setCurrentProductId: any;
  relatedProducts: any;
  loadedLastSeenProducts: any;
  cart: any;
  currentCategoryGroup: any;
  categoriesGroup?: any[];
  mainGroupCategory?: any;
  currentPath: string;
  settings?: any;
  upsell: any;
  currentCategoryId: number;
  deliveryFreePrice: number;
  preorderProductTitleText?: string;
  preorderProductText?: string;
  preorderProductButtonText?: string;
  currentSubgroupVirtualId?: string | null;
}

export interface AttribDemand {
  attrib_id: number;
  attrib_value_id: number;
  attrib_name: string;
  attrib_value_name: string;
}

export interface State {
  count: number;
  goodId: number | null;
  variationError: boolean;
  activeTab: number;
  favoriteMustLoginModalVisible: boolean;
  favoriteProductAddedModalVisible: boolean;
  allowedToAddToCart: boolean;
  attribObj: {};
  attribDemandObj: Array<AttribDemand>;
  personalization: Personalization;
  personalizationError: string;
}

class Product extends React.Component<ProductProps, State> {
  public static async getInitialProps(props) {
    const { product_id, dispatch } = props;

    if (isSsr()) {
      await Promise.all([
        dispatch(setCurrentProductId(product_id)),
        dispatch(loadProductById(product_id, props.cookies)),
        dispatch(loadRelatedProducts(product_id)),
        dispatch(loadProductUpsell(product_id)),
      ]);
      return;
    }

    dispatch(setCurrentProductId(product_id));
    dispatch(setRelatedProducts(null));
    dispatch(setUpsell(null));
    dispatch(setLinkedProducts(null));
    dispatch(loadRelatedProducts(product_id)).catch(() => undefined);
    dispatch(loadProductUpsell(product_id));

    await dispatch(loadProductById(product_id, props.cookies));
  }

  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
  }

  public getDefaultState() {
    return {
      count: 1,
      goodId: null,
      variationError: false,
      activeTab: 0,
      favoriteMustLoginModalVisible: false,
      favoriteProductAddedModalVisible: false,
      allowedToAddToCart: false,
      attribObj: {},
      attribDemandObj: [],
      personalization: { color: '', text: '' },
      personalizationError: '',
    };
  }

  public onGiftOpen = async () => {
    this.props.dispatch(
      setArticleModal(getGiftWebContentIdFromSettings(this.props.settings)),
    );
  };

  public componentDidMount() {
    if (this.props && this.props.product && this.props.product.productDetail) {
      const product = this.props.product.productDetail;
      if (product.main_good) {
        sendViewItemEvent({
          value: product.main_good.final_price,
          items: [
            {
              item_id: product.product_id,
              item_name: product.name,
            },
          ],
        });
      }

      // Load preorder texts if product has allow_preorder and texts are not loaded yet
      if (product.allow_preorder && !this.props.preorderProductButtonText) {
        this.props.dispatch(loadPreorderTexts());
      }
    }

    // Add current product to last seen products and load them
    if (typeof window !== 'undefined') {
      try {
        let localStorageSupported = 'localStorage' in window;
        if (localStorageSupported && localStorage) {
          const currentProductId = this.props?.product?.currentProductId;
          const lastSeenProductsId: number[] = getLastSeenProducts();

          // Add current product to the list if we have one
          let newLastSeenProductsId = lastSeenProductsId;
          if (currentProductId) {
            newLastSeenProductsId = Array.from(
              new Set([currentProductId, ...lastSeenProductsId]),
            ).slice(0, 30);
            setLastSeenProducts(newLastSeenProductsId);
          }

          this.props.dispatch(loadLastSeenProducts());
        }
      } catch (e) {
        console.error('Error in componentDidMount lastSeenProducts:', e);
      }
    }
  }

  public async componentWillUpdate(prevProps) {
    /*
    if(this.props?.product?.productDetail?.productCategoriesBreadcrumbs?.length && this.props?.product?.productDetail?.productCategories?.length){
      const allCategoryIds = this.props?.product?.productDetail?.productCategories.map(pc => pc.category_id);
      if(allCategoryIds.length && !allCategoryIds.includes(this.props.currentCategoryId)){
        const lastCategoryId = this.props.product.productDetail.productCategoriesBreadcrumbs[this.props.product.productDetail.productCategoriesBreadcrumbs.length - 1].category_id;
        this.props.dispatch(setCurrentCategoryId(lastCategoryId));
      }
    }
    */

    if (
      this.props?.product?.currentProductId &&
      prevProps?.product?.currentProductId &&
      this.props.product.currentProductId !== prevProps.product.currentProductId
    ) {
      this.setState({
        attribDemandObj: [],
        count: 1,
      });
    }
  }

  public async componentDidUpdate(prevProps) {
    // Update last seen products when navigating to a different product
    if (
      this.props?.product?.currentProductId &&
      prevProps?.product?.currentProductId !==
        this.props.product.currentProductId &&
      typeof window !== 'undefined'
    ) {
      // Reset state when navigating to a different product
      this.setState(this.getDefaultState());

      try {
        let localStorageSupported = 'localStorage' in window;
        if (localStorageSupported && localStorage) {
          const lastSeenProductsId: number[] = getLastSeenProducts();
          const newLastSeenProductsId: number[] = Array.from(
            new Set([
              this.props.product.currentProductId,
              ...lastSeenProductsId,
            ]),
          ).slice(0, 30);

          if (
            JSON.stringify(newLastSeenProductsId) !==
            JSON.stringify(lastSeenProductsId)
          ) {
            setLastSeenProducts(newLastSeenProductsId);
            this.props.dispatch(loadLastSeenProducts());
          }
        }
      } catch (e) {}

      // Load preorder texts if product has allow_preorder and texts are not loaded yet
      if (
        this.props?.product?.productDetail?.allow_preorder &&
        !this.props.preorderProductButtonText
      ) {
        this.props.dispatch(loadPreorderTexts());
      }
    }
  }

  public onAddFavouriteClick = (e) => {
    const { user } = this.props;
    const instance = this;

    if (user) {
      this.props.dispatch(
        addToFavouriteProducts(
          this.props.product.productDetail.product_id,
          user.id,
          function (response) {
            instance.props.dispatch(updateCurrentProductFavorite(true));
            instance.setState({
              favoriteMustLoginModalVisible: false,
              favoriteProductAddedModalVisible: true,
            });
            instance.props.dispatch(loadFavoriteProductsCount());
          },
        ),
      );
    } else {
      this.setState({
        favoriteMustLoginModalVisible: true,
        favoriteProductAddedModalVisible: false,
      });
    }
  };

  public onFavouriteCancel = (e) => {
    this.setState({
      favoriteMustLoginModalVisible: false,
      favoriteProductAddedModalVisible: false,
    });
  };

  public onFavouriteLogin = (e) => {
    this.props.dispatch(push('/prihlasenie'));
  };

  public onRemoveFavouriteClick = (e) => {
    const { user } = this.props;
    const instance = this;

    if (user) {
      this.props.dispatch(
        removeFromFavouriteProducts(
          this.props.product.productDetail.product_id,
          user.id,
          function (response) {
            instance.props.dispatch(updateCurrentProductFavorite(false));
            instance.props.dispatch(loadFavoriteProductsCount());
          },
        ),
      );
    }
  };

  public onCountChange = (count) => {
    this.setState({
      count: parseInt(count, 10),
    });
  };

  public onPersonalizationChange = (personalization: Personalization) => {
    this.setState({ personalization, personalizationError: '' });
  };

  public setPersonalizationError = (personalizationError: string) => {
    this.setState({ personalizationError });
  };

  public onAddedToCart = async (bool) => {
    try {
      this.props.dispatch(
        setAddToCartModalProduct({
          product: this.props.product.productDetail,
          count: this.state.count,
          goodId: this.state.goodId,
        }),
      );
      this.setState({ variationError: false });
    } catch (e) {
      //
    }
  };

  public onVariationChange = (e) => {
    try {
      const { product } = this.props;
      const { attribObj } = this.state;
      const attribCount = product?.productDetail?.attribs?.length;
      const goods = product.productDetail?.goods;

      const selectedIndex = e.target.options.selectedIndex;
      const attribName =
        e.target.options[selectedIndex].getAttribute('data-key');
      const attribValue = e.target.value;

      attribObj[attribName] = attribValue;
      this.setState({ attribObj: attribObj });

      if (Object.keys(attribObj).length < attribCount) {
        this.setState({ allowedToAddToCart: false });
        this.setState({ attribObj: { ...this.state.attribObj, attribObj } });
      } else {
        let resGood;
        this.setState({ allowedToAddToCart: true });

        for (const good of goods) {
          if (good && good.web_attribs && good.web_attribs.length > 0) {
            let matchedAttribCount = 0;
            good.web_attribs.forEach((attrib) => {
              const attribName = attrib?.attrib_name;
              const attribValue = attrib?.values[0]?.attrib_value;

              if (attribObj[attribName] == attribValue) {
                matchedAttribCount += 1;
              }
            });
            if (matchedAttribCount == attribCount) {
              resGood = good;
              break;
            }
          }
        }

        if (resGood) {
          this.setState({ goodId: resGood.good_id });
          this.setState({ variationError: false });
        }
      }
    } catch (e) {}
  };

  public onDemandVariationChange = (e) => {
    const { product } = this.props;
    const { attribDemandObj } = this.state;
    const attribCount = product?.productDetail?.attribs?.length;

    const selectedIndex = e.target.options.selectedIndex;
    const attribId = e.target.options[selectedIndex].getAttribute('data-key');
    const attribValueId = e.target.value;

    const productAttrib = product?.productDetail?.attribs?.find(
      (attrib) => attrib.attrib_id == attribId,
    );
    const productattribValue = productAttrib?.values?.find(
      (value) => value.value_id == attribValueId,
    );

    let attribDemand = attribDemandObj.find((item) => {
      return item.attrib_id == attribId;
    });

    if (!attribDemand) {
      attribDemand = {
        attrib_id: parseInt(attribId),
        attrib_value_id: parseInt(attribValueId),
        attrib_name: productAttrib.attrib_name,
        attrib_value_name: productattribValue.attrib_value,
      };
      attribDemandObj.push(attribDemand);
    } else {
      (attribDemand.attrib_value_id = parseInt(attribValueId)),
        (attribDemand.attrib_name = productAttrib.attrib_name),
        (attribDemand.attrib_value_name = productattribValue.attrib_value);
    }

    this.setState({
      attribDemandObj: attribDemandObj.map((object) => ({ ...object })),
    });

    if (Object.keys(attribDemandObj).length !== attribCount) {
      this.setState({ allowedToAddToCart: false });
    } else {
      this.setState({ allowedToAddToCart: true });
    }
  };

  public setVariationError = (error) => {
    this.setState({ variationError: error });
  };

  public onTabChange = (id) => {
    this.setState({
      activeTab: id,
    });
  };

  public onDescriptionButtonClick = () => {
    scrollToElement('product-tabs', window.innerWidth > 1024 ? 200 : 50);
  };

  public render() {
    const {
      product,
      dispatch,
      cart,
      currentCategoryGroup,
      user,
      settings,
      currentSubgroupVirtualId,
    } = this.props;
    const { variationError, goodId } = this.state;
    const { productDetail } = product;

    const isPersonalized = isPersonalizedProduct(productDetail, settings);
    const personalizationColors = getPersonalizationColors(settings);
    const personalization = withDefaultPersonalizationColor(
      this.state.personalization,
      personalizationColors,
    );

    let mainDescriptionAvailable = false;

    const productTabs: TabItem[] = [];

    if (
      product.productDetail !== null &&
      typeof product.productDetail.publish[0]?.content?.json_content?.body ===
        'string' &&
      product.productDetail.publish[0]?.content?.json_content.body !== '' &&
      removeHtmlTags(
        product.productDetail.publish[0]?.content?.json_content?.body,
      ) !==
        product.productDetail.publish[0]?.content?.json_content
          ?.short_description
    ) {
      mainDescriptionAvailable = true;
      productTabs.push({
        name: __('Popis produktu'),
        body: <ProductDescription product={product} />,
      });
    }

    if (
      productDetail?.publish &&
      productDetail.publish[0]?.content?.downloads?.length
    ) {
      productTabs.push({
        name: __('Na stiahnutie'),
        body: <ProductDownloads product={product} className="detail" />,
      });
    }

    const items: any = [];
    if (product && productDetail?.productCategoriesBreadcrumbs?.length > 0) {
      const stopCategoryIds: number[] = [];
      let brEnabled = true;

      // Find matching subgroup only when user is in a subgroup context
      const matchingSubgroup = currentSubgroupVirtualId
        ? currentCategoryGroup?.subgroups?.find(
            (sg) =>
              `subgroup_${sg.id}` === currentSubgroupVirtualId &&
              (sg.categories || []).some((sgCat) =>
                productDetail.productCategoriesBreadcrumbs.some(
                  (bc) => bc.category_id === sgCat.category_id,
                ),
              ),
          )
        : undefined;

      if (currentCategoryGroup) {
        for (const fullCategoryGroupCategory of currentCategoryGroup.categories) {
          stopCategoryIds.push(fullCategoryGroupCategory.category_id);
        }

        if (matchingSubgroup) {
          for (const sgCat of matchingSubgroup.categories || []) {
            stopCategoryIds.push(sgCat.category_id);
          }
        }

        items.push({
          name: capitalizeFirstLetter(currentCategoryGroup.name),
          url: currentCategoryGroup.uniqid_url,
        });
      }

      if (stopCategoryIds.length) {
        brEnabled = false;
      }

      for (const productCategory of productDetail.productCategoriesBreadcrumbs) {
        if (stopCategoryIds.includes(productCategory.category_id)) {
          brEnabled = true;
        }

        if (brEnabled) {
          items.push({
            name: capitalizeFirstLetter(productCategory.category_name),
            url: items.length !== 0 ? productCategory.url : null,
          });
        }
      }
      if (currentCategoryGroup) {
        items.splice(0, 1, {
          name: capitalizeFirstLetter(currentCategoryGroup.name),
          url: currentCategoryGroup.uniqid_url,
        });
      }

      if (matchingSubgroup) {
        items.splice(1, 0, {
          name: capitalizeFirstLetter(matchingSubgroup.name),
          url:
            matchingSubgroup.uniqid_url ||
            matchingSubgroup.categories?.[0]?.url ||
            null,
        });
      }
    }

    // Názov produktu sa v breadcrumbs nezobrazuje - posledná položka je kategória

    const outOfStock = isOutOfStock(productDetail);

    let isLinkedProductsAvailable = false;
    if (
      this.props.product.linkedProducts &&
      this.props.product.linkedProducts.length > 1
    ) {
      for (const linkedProduct of this.props.product.linkedProducts) {
        if (!isOutOfStock(linkedProduct)) {
          isLinkedProductsAvailable = true;
          break;
        }
      }
    }

    const isGiftsVisible =
      (!user || isRetail(user)) && isCartGiftsValid(settings, user);

    return (
      <MediaContextProvider>
        {this.state.favoriteProductAddedModalVisible ? (
          <FavoriteAddedModal
            title={__('Pridané do obľúbených produktov')}
            bodyText={
              <>
                <span>
                  {' '}
                  {__(
                    'Produkt úspešne pridaný do vaších obľúbených produktov.',
                  )}{' '}
                </span>
                <br />
                <span>
                  {' '}
                  {__('Prehľad obľúbených produktov nájdete v sekcii')}{' '}
                  <strong>
                    {' '}
                    {__('Môj účet')} /{' '}
                    <FavoriteModalLink href="/my-account/favorite-products">
                      {__('Obľúbené produkty')}
                    </FavoriteModalLink>{' '}
                  </strong>{' '}
                </span>
              </>
            }
            buttonText={__('Pokračovať')}
            buttonPositionDesktop="right"
            titleFontWeight="bold"
            onCloseButtonClick={this.onFavouriteCancel}
            onButtonClick={this.onFavouriteCancel}
          />
        ) : (
          ''
        )}

        {this.state.favoriteMustLoginModalVisible ? (
          <FavoriteMustLoginModal
            title={__('Potrebné prihlásenie')}
            bodyText={
              <>
                <span>
                  {' '}
                  {__(
                    'Aby ste mohli pridať produkt do vašich obľúbených produktov, je potrebné byť prihlásený do vašeho daffer účtu. Ak ešte nemáte svoj daffer účet, môžete sa',
                  )}{' '}
                  <strong>
                    {' '}
                    <FavoriteModalLink href="/registracia">
                      {' '}
                      {__('zaregistrovať tu')}
                    </FavoriteModalLink>
                  </strong>
                  .{' '}
                </span>
              </>
            }
            button1Text={__('Zrušiť pridanie')}
            button2Text={__('Prihlásenie')}
            onButton1Click={this.onFavouriteCancel}
            onButton2Click={this.onFavouriteLogin}
            onCloseButtonClick={this.onFavouriteCancel}
          />
        ) : (
          ''
        )}

        <ProductContainer className="base">
          <MetaTags tags={productMetaHandler(productDetail, 'Daffer.sk')} />
          {productDetail &&
            (() => {
              const productJsonLd = buildProductJsonLd(productDetail);
              /*
              const breadcrumbJsonLd =
                items.length > 0
                  ? {
                      '@context': 'https://schema.org',
                      '@type': 'BreadcrumbList',
                      itemListElement: items.map((item, index) => ({
                        '@type': 'ListItem',
                        position: index + 1,
                        name: item.name,
                        ...(item.url && {
                          item: item.url.startsWith('http')
                            ? item.url
                            : `${process.env.REACT_APP_URL}${
                                item.url.startsWith('/') ? '' : '/'
                              }${item.url}`,
                        }),
                      })),
                    }
                  : null;
                */
              return (
                <Helmet>
                  {productJsonLd && (
                    <script type="application/ld+json">
                      {JSON.stringify(productJsonLd)}
                    </script>
                  )}
                  {/*
                {breadcrumbJsonLd && (
                  <script type="application/ld+json">
                    {JSON.stringify(breadcrumbJsonLd)}
                  </script>
                )}
                */}
                </Helmet>
              );
            })()}
          <CatalogRow>
            <CategoriesCol>
              {currentCategoryGroup?.uniqid === 'FURNITURE_SCHOOL' ? (
                <FlushSideMenu
                  categoriesGroup={this.props.categoriesGroup || []}
                  dispatch={dispatch}
                  currentPath={this.props.currentPath}
                  activeCategoryId={this.props.currentCategoryId}
                  furniture={true}
                />
              ) : (
                <FlushSideMenu
                  categoriesGroup={this.props.categoriesGroup || []}
                  dispatch={dispatch}
                  currentPath={this.props.currentPath}
                  activeGroupId={currentCategoryGroup?.id}
                />
              )}

              {isCartGiftsValid(settings, user) &&
              currentCategoryGroup?.uniqid !== 'FURNITURE_SCHOOL' ? (
                <GiftImage
                  src={getGiftCategoryDesktopBannerFromSettings(settings)}
                  onClick={this.onGiftOpen}
                />
              ) : (
                <></>
              )}
            </CategoriesCol>

            <MainColStyled>
              <Breadcrumbs items={items} lastAsLink={true} />
              <ProductRow>
                <Media lessThan="xl">
                  <ProductMetaCol>
                    <TitleAboveGallery>
                      <ProductTitle product={product} />
                    </TitleAboveGallery>
                  </ProductMetaCol>
                </Media>
                <GalleryCol>
                  <ProductGallery
                    product={product}
                    user={user}
                    settings={settings}
                  />
                </GalleryCol>
                <ProductMetaCol>
                  <ProductBody>
                    <Media greaterThanOrEqual="xl">
                      <ProductTitle product={product} />
                    </Media>
                    <Media lessThan="md">
                      <br />
                    </Media>
                    {productDetail ? (
                      <>
                        <ProductShortDescription
                          product={productDetail}
                          className="detail"
                        />
                        {isPersonalized && (
                          <ProductPersonalizationForm
                            colors={personalizationColors}
                            infoText={settings?.personalization?.info_text}
                            personalization={personalization}
                            error={this.state.personalizationError}
                            onChange={this.onPersonalizationChange}
                          />
                        )}
                        {isCompanyOrSchoolAccount(user) && (
                          <ProductPackagingInfo product={productDetail} />
                        )}
                        {mainDescriptionAvailable ? (
                          <DescriptionButton
                            onClick={this.onDescriptionButtonClick}
                          >
                            <InfoIcon icon="info" />{' '}
                            {__('VIAC INFO O PRODUKTE')}
                          </DescriptionButton>
                        ) : (
                          <></>
                        )}
                        <div>
                          <b>Kód: </b>{' '}
                          {productDetail?.product_plu?.startsWith('S')
                            ? `${productDetail?.product_plu}-${productDetail?.product_ean}`
                            : productDetail?.product_plu}
                        </div>
                        {productDetail.on_demand ? (
                          <ProductDemandVariantSelect
                            key={`variant-${productDetail.product_id}`}
                            product={productDetail}
                            onChange={this.onDemandVariationChange}
                            isError={variationError}
                            attribDemandObj={this.state.attribDemandObj}
                          />
                        ) : (
                          <ProductVariantSelect
                            key={`variant-${productDetail.product_id}`}
                            product={productDetail}
                            onChange={this.onVariationChange}
                            isError={variationError}
                            attribsObject={this.state.attribObj}
                          />
                        )}
                        {isLinkedProductsAvailable ? (
                          <AlternativesWrapper>
                            <div>
                              <b> {__('Ďalšie farby/motívy:')} </b>
                            </div>
                            <ProductAlternatives product={product} />
                          </AlternativesWrapper>
                        ) : (
                          <></>
                        )}

                        {!outOfStock ||
                        productDetail?.on_demand ||
                        productDetail?.allow_preorder ? (
                          <>
                            <ProductPrice
                              product={product}
                              user={this.props.user}
                              cart={this.props.cart}
                              settings={this.props.settings}
                            />
                            {productDetail && !productDetail.on_demand && (
                              <>
                                <AvailabilityDetail
                                  key={`availability-${productDetail.product_id}`}
                                  dispatch={this.props.dispatch}
                                  productDetail={productDetail}
                                />
                                {productDetail?.allow_preorder &&
                                  outOfStock && (
                                    <PreorderWrapper>
                                      {this.props.preorderProductTitleText && (
                                        <PreorderTitle
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              this.props
                                                .preorderProductTitleText,
                                          }}
                                        />
                                      )}
                                      {this.props.preorderProductText && (
                                        <PreorderText
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              this.props.preorderProductText,
                                          }}
                                        />
                                      )}
                                    </PreorderWrapper>
                                  )}
                              </>
                            )}
                            <ProductForm
                              count={this.state.count}
                              goodId={goodId}
                              product={product}
                              dispatch={dispatch}
                              onCountChange={this.onCountChange}
                              showModal={this.onAddedToCart}
                              setVariationError={this.setVariationError}
                              cart={cart}
                              attribDemandObj={this.state.attribDemandObj}
                              preorderProductButtonText={
                                this.props.preorderProductButtonText
                              }
                              personalization={
                                isPersonalized ? personalization : null
                              }
                              setPersonalizationError={
                                this.setPersonalizationError
                              }
                            />

                            {(this.props.deliveryFreePrice ||
                              this.props.deliveryFreePrice === 0) &&
                            !productDetail.on_demand ? (
                              <CartShippingRangeStyled
                                cart={cart}
                                user={user}
                                freeShippingPrice={this.props.deliveryFreePrice}
                                size="small"
                              />
                            ) : (
                              <></>
                            )}

                            {isGiftsVisible && !productDetail.on_demand ? (
                              <CartGiftSmallWidgetWrapper>
                                <CartGiftSmallWidget
                                  dispatch={dispatch}
                                  cart={cart}
                                />
                              </CartGiftSmallWidgetWrapper>
                            ) : (
                              ''
                            )}

                            <ProductManufacturer
                              manufacturer={
                                productDetail
                                  ? productDetail.manufacturer
                                  : null
                              }
                            />

                            <ProductFavoriteWrapper>
                              <ProductFavorite
                                isFavorite={
                                  productDetail
                                    ? productDetail.is_user_favorite
                                    : false
                                }
                                onAddClick={this.onAddFavouriteClick}
                                onRemoveClick={this.onRemoveFavouriteClick}
                              />
                            </ProductFavoriteWrapper>
                            {this.props.upsell ? (
                              <ProductUpsell
                                originalProduct={this.props.product}
                                upsell={this.props.upsell}
                                dispatch={this.props.dispatch}
                              />
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <>
                            {productDetail && !productDetail.on_demand && (
                              <AvailabilityDetailStyled
                                key={`availability-${productDetail.product_id}`}
                                dispatch={this.props.dispatch}
                                productDetail={productDetail}
                              />
                            )}
                            <ProductManufacturer
                              manufacturer={
                                productDetail
                                  ? productDetail.manufacturer
                                  : null
                              }
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </ProductBody>
                </ProductMetaCol>
              </ProductRow>
              {productTabs && productTabs.length ? (
                <Tabs
                  items={productTabs.map((p, index) => {
                    return { ...p, id: index };
                  })}
                  activeId={this.state.activeTab}
                  onTabChange={this.onTabChange}
                  className="product-tabs"
                />
              ) : (
                ''
              )}

              {this.props.relatedProducts?.products?.length ? (
                <ProductsSlider
                  title={__('Súvisiace produkty')}
                  products={this.props.relatedProducts.products}
                />
              ) : (
                ''
              )}
              {this.props.loadedLastSeenProducts?.products?.filter(
                (p) => p.product_id !== this.props.product?.currentProductId,
              )?.length ? (
                <ProductsSlider
                  title={__('Naposledy zobrazené položky')}
                  products={this.props.loadedLastSeenProducts.products.filter(
                    (p) =>
                      p.product_id !== this.props.product?.currentProductId,
                  )}
                />
              ) : (
                ''
              )}
            </MainColStyled>
          </CatalogRow>
        </ProductContainer>
      </MediaContextProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isCartProcessing: state.cart.isProcessing,
    lang: state.general.lang,
    defaultTitle: state.general.title,
    activeVariant: activeVariantByIdSelector(state),
    product: state.product,
    relatedProducts: prop(state.product, 'relatedProducts', {}),
    loadedLastSeenProducts: prop(state.product, 'loadedLastSeenProducts', {}),
    upsell: prop(state.product, 'upsell', null),
    user: state.auth.user,
    cart: state.cart.cart,
    currentCategoryGroup: state.general.currentCategoryGroup,
    categoriesGroup: state.general.categoriesGroup,
    mainGroupCategory: state.general.mainGroupCategory,
    currentPath: prop(state.routing, 'locationBeforeTransitions.pathname', ''),
    settings: state.general.settings,
    currentCategoryId: prop(state, 'general.currentCategoryId'),
    deliveryFreePrice: state.general.deliveryFreePrice,
    preorderProductTitleText: preorderProductTitleTextSelector(state),
    preorderProductText: preorderProductTextSelector(state),
    preorderProductButtonText: preorderProductButtonTextSelector(state),
    currentSubgroupVirtualId: state.general.currentSubgroupVirtualId ?? null,
  };
};

export default connect(mapStateToProps)(Product);
